// components/ClaimRow.jsx
import React from "react";
import ClaimNameCell from "./tds/ClaimNameCell";
import SubmittedBillingCell from "./tds/SubmittedBillingCell";
import GeneratedDocCell from "./tds/GeneratedDocCell";
import SeverityLevelCell from "./tds/SeverityLevelCell";
import ClaimTypeCell from "./tds/ClaimTypeCell";
import PickDateCell from "./tds/PickDateCell";
import InvoiceTypeCell from "./tds/InvoiceTypeCell";
import GenderCell from "./tds/GenderCell";
import CheckCell from "./tds/CheckCell";
import AddressSearchCell from "./tds/AddressSearchCell";
import PenaltyChargeCell from "./tds/PenaltyChargeCell";
import ChangeStatusCell from "./tds/ChangeStatusCell";
import CustomStatusCell from "./tds/CustomStatusCell";
import AddNotesCell from "./tds/AddNotesCell";
import StatusCell from "./tds/StatusCell";
import ActionsCell from "./tds/ActionsCell";
import Amount from "./tds/Amount";
const ClaimRow = ({
    claim, handleGenerateAi, handleViewAi, handleApprove, handleReject, handleStart, handleComplete, setSelectedClaim, setSelectedClaimNotes, setAddressSearch, addressSearch, handleStatusChange, setChecks, checks, claimTypes, setClaimTypes, customStatuses, handleSaveStatus, genders, setGenders, invoiceTypes, setInvoiceTypes, setActiveClaimId, setShowCustomModal, setCustomInvoiceTypes, penaltyCharges, setPenaltyCharges, pickedDates, setPickedDates, severityLevels, setSeverityLevels, getStatusBadge, processingAi, processingClaims, handleViewClick, setUserToDelete
    , setDeleteSuccess, setDeleteError, setShowDeleteModal, showCustomModal,
    customInvoiceTypes,
    activeClaimId,
    handleChatClick, unread, unreadUsers
}) => {
    return (
        <tr key={claim._id}>
            <ClaimNameCell
                claim={claim}
            />
            <SubmittedBillingCell
                claim={claim}
            />
            <GeneratedDocCell
                claim={claim}
            />
            <Amount claim={claim} />
            <SeverityLevelCell
                claim={claim}
                severityLevels={severityLevels}
                setSeverityLevels={setSeverityLevels}
            />
            <ClaimTypeCell
                claim={claim}
                claimTypes={claimTypes}
                setClaimTypes={setClaimTypes}
            />

            <InvoiceTypeCell
                claim={claim}
                invoiceTypes={invoiceTypes}
                setInvoiceTypes={setInvoiceTypes}
                setActiveClaimId={setActiveClaimId}
                setShowCustomModal={setShowCustomModal}
                setCustomInvoiceTypes={setCustomInvoiceTypes}

                showCustomModal={showCustomModal}
                customInvoiceTypes={customInvoiceTypes}
                activeClaimId={activeClaimId}
            />
            {/* <GenderCell
                claim={claim}
                genders={genders}
                setGenders={setGenders}
            /> */}
            <CheckCell
                claim={claim}
                checks={checks}
                setChecks={setChecks}

            />
            <AddressSearchCell
                claim={claim}
                setAddressSearch={setAddressSearch}
                addressSearch={addressSearch} />
            <PenaltyChargeCell
                claim={claim}
                penaltyCharges={penaltyCharges}
                setPenaltyCharges={setPenaltyCharges}
            />
            <ChangeStatusCell
                claim={claim}
                handleStatusChange={handleStatusChange}
            />
            <CustomStatusCell
                claim={claim}
                customStatuses={customStatuses}
                handleSaveStatus={handleSaveStatus}
            />
            <AddNotesCell
                claim={claim}
                setSelectedClaimNotes={setSelectedClaimNotes} />
            <StatusCell
                claim={claim}
                getStatusBadge={getStatusBadge}
            />
            <ActionsCell
                claim={claim}
                handleGenerateAi={handleGenerateAi}
                handleViewAi={handleViewAi}
                handleApprove={handleApprove}
                handleReject={handleReject}
                handleStart={handleStart}
                handleComplete={handleComplete}
                processingAi={processingAi}
                processingClaims={processingClaims}
                handleViewClick={handleViewClick}
                setUserToDelete={setUserToDelete}
                setDeleteSuccess={setDeleteSuccess}
                setDeleteError={setDeleteError}
                setShowDeleteModal={setShowDeleteModal}
                handleChatClick={handleChatClick}
                unread={unread}
                unreadUsers={unreadUsers}
            />



        </tr>
    );
};

export default ClaimRow;
